import type { AuthMethod } from "@defuse-protocol/internal-utils"
import type {
  QuoteRequest,
  QuoteResponse,
} from "@defuse-protocol/one-click-sdk-typescript"
import { isQuoteSignatureError } from "@src/components/DefuseSDK/utils/verifyQuoteSignature"
import { getQuote as get1csQuoteApi } from "./1cs"

// Keep the signed response intact so execution paths can persist it.
export type Quote1csResult =
  | { ok: QuoteResponse & { appFee: [string, bigint][] } }
  | {
      err: string
      correlationId?: string
      originalRequest?: QuoteRequest | undefined
    }

export function quoteFailureReason(
  error: string
): "ERR_QUOTE_SIGNATURE_INVALID" | "ERR_1CS_QUOTE_FAILED" {
  return isQuoteSignatureError(error)
    ? "ERR_QUOTE_SIGNATURE_INVALID"
    : "ERR_1CS_QUOTE_FAILED"
}

export type Quote1csClientParams = {
  dry: boolean
  slippageTolerance: number
  originAsset: string
  destinationAsset: string
  amount: string
  deadline: string
  userAddress: string
  authMethod: AuthMethod
  swapType: QuoteRequest.swapType
  isConfidential?: boolean
  isAuthenticated: boolean
}

export type Quote1csClient = (
  params: Quote1csClientParams
) => Promise<Quote1csResult>

export const defaultQuote1csClient: Quote1csClient = (params) =>
  get1csQuoteApi(params)
